import React from "react";
import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../features/api/apiSlice";
import Book from "./Book";

export default function Books() {
  const { data: books, isLoading, isError } = useGetBooksQuery();
  const { featured, search } = useSelector((state) => state.filter);

  const filteredBooksBySearch = books?.filter((book) =>
    book.name.toLowerCase().includes(search.toLowerCase())
  );
  const filteredBooksByFeatured = filteredBooksBySearch?.filter((book) => {
    // if selected all in filter then return all the books else
    // only return the featured books
    if (!featured) {
      return true;
    } else {
      return book.featured === featured;
    }
  });

  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>There was an error fetching the books!</div>;
  }
  if (!isLoading && !isError && filteredBooksByFeatured.length === 0) {
    content = <div>No books were found!</div>;
  }
  if (!isLoading && !isError && filteredBooksByFeatured.length > 0) {
    content = filteredBooksByFeatured.map((book) => (
      <Book key={book.id} book={book} />
    ));
  }
  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {content}
    </div>
  );
}
